<template>
  <el-select :value="value" @input="$emit('input', $event)" @change="$emit('change', $event)">
    <el-option v-for="item in options" :key="item.value" :value="item.code" :label="item.name"/>
  </el-select>
</template>

<script>
import { fetchByKey } from '@/api/system/config'
let _vue = null
export default {
  name: 'BookScopeSelect',
  props: {
    value: {},
    docType: {}
  },
  data () {
    return {
      introduceData: null,
      zbsData: null
    }
  },
  computed: {
    options () {
      if (_vue.docType === 'ZBS' && _vue.zbsData != null) {
        return _vue.zbsData.scopes
      }
      if (_vue.docType === 'SYS_INT' && _vue.introduceData != null) {
        return _vue.introduceData.scopes
      }
      return []
    }
  },
  methods: {
    // 配置说明书
    fetchIntroduceScopes () {
      fetchByKey('book:system:introduce:config')
        .then(data => {
          this.introduceData = JSON.parse(data.value)
        })
        .catch(e => {
          this.$tip.apiFailed(e)
        })
    },
    // 配置招标书
    fetchZbsScopes () {
      fetchByKey('book:zbs:config')
        .then(data => {
          this.zbsData = JSON.parse(data.value)
        })
        .catch(e => {
          this.$tip.apiFailed(e)
        })
    }
  },
  created () {
    _vue = this
    this.fetchIntroduceScopes()
    this.fetchZbsScopes()
  }
}
</script>
